module.exports = __webpack_public_path__ + "static/media/locate.dd1c09ef.svg";